import React from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { globalStyles, noop } from "@client/shared/constants";
import Autocomplete from "@mui/material/Autocomplete";

const BroadcastPanelView = ({
  broadcastTitle = "",
  callerIdName = "",
  callerIdNumber = "",
  overrideCallerId = false,
  errors = {},
  phoneNumberList = [],
  handleChange = noop,
}) => {
  return (
    <>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            ...globalStyles.text.weight.bold,
          }}
        >
          Campaign Name
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="Campaign Name..."
          name="broadcastTitle"
          value={broadcastTitle}
          helperText={errors.broadcastTitle}
          error={!!(errors.broadcastTitle || "").trim()}
          onChange={handleChange}
        />
      </Box>
    </>
  );
};

export default BroadcastPanelView;
